import {CommonService} from '../services/common.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {DistributionArea} from '../models/DistributionArea';
import {MatTabGroup} from '@angular/material/tabs';
import {MatTableDataSource} from '@angular/material';
import {ToastMessagesService} from '../services/toast-messages.service';

@Component({
  styleUrls: ['./distribution-locations-limits.component.scss'],
  templateUrl: './distribution-locations-limits.component.html'
})
export class DistributionLocationsLimitsComponent implements OnInit {
  salesGroups: MatTableDataSource<DistributionArea>;
  selectedRowIndex: number;
  displayedColumns = ['id', 'name'];
  limitTitle: string;
  salesGroupsAdv: any;
  itemsAdv: any;
  loadingSalesGroups: boolean;
  loadingSalesGroupsLimits: boolean;
  selectedDistributionArea: DistributionArea;
  selectedDistributionAreaLimits = [];
  items: MatTableDataSource<any> = new MatTableDataSource<any>();
  selectedItem: any;
  selectedItemTitle;
  selectedItemLimits = [];
  selectedItemRowIndex: number;
  @ViewChild(MatTabGroup, {static: false}) tabGroup: MatTabGroup;

  constructor(private commonService: CommonService,
              private toastMessagesService: ToastMessagesService) {
    this.limitTitle = 'Όρια περιοχής διανομής';
    this.loadingSalesGroups = true;
    this.loadingSalesGroupsLimits = false;
    this.selectedItemTitle = 'Όρια ομάδας ειδών 1';
  }

  public async ngOnInit(): Promise<any> {
    await this.initSalesGroups();
  }

  async initSalesGroups() {
    const salesGroups: DistributionArea[] = [];
    try {
      this.salesGroupsAdv = await this.commonService.getSimpleList(`agreement/approval_limits`) as any;

      for (const salesGroup of this.salesGroupsAdv) {
        salesGroups.push({
          id: salesGroup.sales_group_id,
          name: salesGroup.sales_group_description,
          has_null_value: salesGroup.has_null_value,
          selected: false
        });

        for (const limit of salesGroup.limits) {
          limit.originalValue = limit.value;
        }
      }

      this.salesGroups = new MatTableDataSource<DistributionArea>(salesGroups);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.loadingSalesGroups = false;
    }
  }

  async getDistributionAreaItems(id) {
    try {
      const items = [];
      this.itemsAdv = await this.commonService.getList(`agreement/approval_limits/items/${id}`) as any;
      for (const item of this.itemsAdv) {
        const model = {
          item_group1_id: item.item_group1_id,
          item_group1_description: item.item_group1_description,
          selected: false
        };
        for (const limit of item.limits) {
          limit.originalValue = limit.value;
        }
        items.push(model);
      }
      this.items = new MatTableDataSource<any>(items);
    } catch (e) {
      throw e;
    }
  }

  applyFilter(value: any) {
    this.loadingSalesGroups = true;
    this.salesGroups.filter = value.toLowerCase();
    this.loadingSalesGroups = false;
  }

  applyItemFilter(value: any) {
    this.items.filter = value.trim().toLocaleLowerCase();
  }

  async onRowClick(row: DistributionArea) {
    this.tabGroup.selectedIndex = 0;
    this.loadingSalesGroupsLimits = true;
    this.selectedItem = null;
    this.selectedItemRowIndex = null;
    this.selectedItemTitle = 'Όρια ομάδας ειδών 1';
    this.selectedRowIndex = +row.id;
    try {
      this.selectedDistributionArea = row;
      this.limitTitle = `${row.id} - ${row.name}`;
      const info = this.salesGroupsAdv.filter(salesGroup => salesGroup.sales_group_id === row.id);

      this.selectedDistributionAreaLimits = [];
      this.selectedDistributionAreaLimits = info[0].limits;
      await this.getDistributionAreaItems(row.id);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.loadingSalesGroupsLimits = false;
    }
  }

  onItemClick(row) {
    this.selectedItem = row;
    this.selectedItemRowIndex = row.item_group1_id;
    this.selectedItemTitle = `${row.item_group1_id} - ${row.item_group1_description}`;
    const currentItem = this.itemsAdv.find(item => item.item_group1_id === row.item_group1_id);
    this.selectedItemLimits = currentItem.limits;
    this.tabGroup.selectedIndex = 1;
  }

  async updateDistributionAreaLimit(limit, value) {
    this.loadingSalesGroupsLimits = true;
    try {
      const model = {
        id: limit.id,
        agreement_approval_limit_id: limit.agreement_approval_limit_id,
        sales_group_id: this.selectedDistributionArea.id,
        value
      };

      await this.commonService.updateObject(`agreement/approval_limits`, model);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.loadingSalesGroupsLimits = false;
    }
  }

  async updateItemLimit(limit, value) {
    this.loadingSalesGroupsLimits = true;
    try {
      const model = {
        id: limit.id,
        agreement_approval_limit_id: limit.agreement_approval_limit_id,
        agreement_approval_limit_sales_group_id: limit.agreement_approval_limit_sales_group_id,
        sales_group_id: +this.selectedDistributionArea.id,
        item_group1_id: this.selectedItem.item_group1_id,
        value
      };

      await this.commonService.updateObject(`agreement/approval_limits/items`, model);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.loadingSalesGroupsLimits = false;
    }
  }


  async updateValue(limit) {
    if (limit.value !== limit.originalValue) {
      await this.updateDistributionAreaLimit(limit, limit.value);
    }
  }

  async updateItemValue(limit: any) {
    if (limit.value !== limit.originalValue) {
      await this.updateItemLimit(limit, limit.value);
    }
  }

  async updateCheckBox(limit) {
    limit.value = limit.value === 1 ? 0 : 1;
    await this.updateDistributionAreaLimit(limit, limit.value);
  }

  async updateCheckItemBox(limit: any) {
    limit.value = limit.value === 1 ? 0 : 1;
    await this.updateItemLimit(limit, limit.value);
  }
}
